import { Component, OnInit } from '@angular/core';
import { DirectEditService } from '@app/modules/direct/services/direct-edit.service';
import { NotificationType } from '@app/shared/interfaces';
import { DirectProperty, PropertiesService } from '@app/shared/services/properties/properties.service';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { DirectService } from '../../services/direct.service';

@Component({
  standalone: false,
  selector: 'sbnb-direct-edit-properties',
  templateUrl: './direct-edit-properties.component.html',
  styleUrls: ['./direct-edit-properties.component.scss'],
})
export class DirectEditPropertiesComponent implements OnInit {
  properties: DirectProperty[] = [];
  saving: boolean;

  get site() {
    return this.directEditService.site;
  }

  constructor(
    public readonly directEditService: DirectEditService,
    private readonly direct: DirectService,
    private readonly propertiesService: PropertiesService,
    private readonly toast: ToastNotificationsService
  ) {}

  ngOnInit(): void {
    this.propertiesService.getDirectProperties().subscribe((res) => (this.properties = res));
  }

  save() {
    // Synchronize properties to ensure consistency
    this.synchronizeProperties();

    // Check if any properties are blocked first
    if (this.doWeHaveBlockedProperties()) {
      return;
    }

    this.saving = true;

    this.direct
      .saveSiteProperties(
        this.directEditService.site.id,
        'internal',
        this.directEditService.site.properties,
        this.directEditService.site.include_future_properties
      )
      .subscribe(
        () => {
          this.saving = false;
        },
        () => {
          this.toast.open(
            'There was a problem updating the properties for this site.',
            'Dismiss',
            NotificationType.Error
          );

          this.saving = false;
        }
      );
  }

  /**
   * Ensures that all property IDs in site.properties exist in the properties array
   * Removes any property IDs that don't have corresponding property objects
   */
  private synchronizeProperties(): void {
    if (!this.directEditService.site || !this.directEditService.site.properties || !this.properties) {
      return;
    }

    // Filter out property IDs that don't exist in this.properties
    this.directEditService.site.properties = this.directEditService.site.properties.filter(propId =>
      this.properties.some(prop => prop.id === propId)
    );
  }

  doWeHaveBlockedProperties(): boolean {
    let blockFound = false;

    this.directEditService.site.properties.forEach((propId) => {
      const property = this.properties.find((prop) => prop.id === propId);

      const checks = property.checks.filter((check) => check.id !== 'google_vacation_rentals');

      if (checks.some((check) => check.result === 'block')) {
        this.toast.open(
          'You cannot save this site with the selected properties. Please resolve issues with the properties and try again.',
          'Dismiss',
          NotificationType.Error
        );
        blockFound = true;
      }
    });

    return blockFound;
  }

  propertiesChange(properties: number[]) {
    this.directEditService.setSite({ properties });
  }

  futurePropertiesChange(futureProperties: boolean) {
    this.directEditService.setSite({ include_future_properties: futureProperties });
  }
}
